export let MessageContentType = /*#__PURE__*/ function (MessageContentType) {
    MessageContentType[MessageContentType["TextPlain"] = 0] = "TextPlain";
    // text/plain,
    MessageContentType[MessageContentType["TextMarkdown"] = 1] = "TextMarkdown";
    // text/markdown
    MessageContentType[MessageContentType["TextHtml"] = 2] = "TextHtml";
    // text/html
    MessageContentType[MessageContentType["Image"] = 3] = "Image";
    // IANA have not registered jpg type!
    MessageContentType[MessageContentType["Gallery"] = 4] = "Gallery";
    // It can contain both pictures and videos
    MessageContentType[MessageContentType["Kml"] = 5] = "Kml";
    // application/vnd.google-earth.kml+xml, http://earth.google.com/kml/
    MessageContentType[MessageContentType["Attachment"] = 6] = "Attachment";
    // For all other not handled known/ and unknown file types
    MessageContentType[MessageContentType["AttachmentList"] = 7] = "AttachmentList";
    // Maybe it would be better to have only AttachmentList? One Attachments is a special case of AttachmentList
    MessageContentType[MessageContentType["Video"] = 8] = "Video";
    // Single video file
    MessageContentType[MessageContentType["VCard"] = 9] = "VCard";
    // application/vcard+json or text/vcard
    MessageContentType[MessageContentType["Other"] = 255] = "Other"; // Any other custom type
    return MessageContentType;
}({});
